<template>
    <div class="view view--edit-startdesk-category">
        <edit-startdesk-category v-bind:id="id" />
    </div>
</template>

<script>
    import editStartdeskCategory from '../../../components/EditStartdeskCategory.vue';

    export default {
        components: {
            editStartdeskCategory
        },
        data: function () {
            return {
                id: parseInt(this.$route.params.category) || null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/startdesks/categories/Edit.vue